import { Component, OnInit, Inject } from '@angular/core';
import { XsAppConfigService } from 'src/app/common/services/xs-app-config.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { XsMessageBoxComponent } from "src/app/common/widgets/xs-message-box/xs-message-box.component";
import { SsoService } from "../../../services/sso.service";
import { CookieService } from 'ngx-cookie-service';
import { UsuarioService } from 'src/app/plusd/services/usuario.service';
import Swal from 'sweetalert2'
export interface parametro {
  idUsuario: number;
  idUsuarioRuc: number;
}

@Component({
  selector: 'app-xs-perfil',
  templateUrl: './xs-perfil.component.html',
  styleUrls: ['./xs-perfil.component.css']
})

export class XsPerfilComponent implements OnInit {

  permiso: string = "";
  titulo: string = " Cambio de Contraseña";
  solicitud: any = {};

  claveActual: string = ""
  claveNueva: string = ""
  claveNuevaConfirmacion: string = ""
  click: boolean = false;

  minClave: number = 6;

  constructor(
    public xsAppConfigService: XsAppConfigService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<XsPerfilComponent>,
    public usuario: UsuarioService,
    public ssoService: SsoService,
    public cookieService: CookieService,
    @Inject(MAT_DIALOG_DATA) public parametro: parametro,
  ) { }

  ngOnInit() {
    this.inicializar();
  }

  inicializar() {

  }

  onKeyup1(event) {
    this.activarAceptar();
  }

  onKeyup2(event) {
    this.activarAceptar();
  }

  onKeyup3(event) {
    this.activarAceptar();
  }

  activarAceptar() {
    if (this.claveActual != '' && this.claveNueva != '' && this.claveNuevaConfirmacion != '') {
      this.click = true;
    } else {
      this.click = false;
    }
  }

  onClickCancelar() {
    this.dialogRef.close({ data: null, estado: "CANCELAR" });
  }

  onClickAceptar() {
    this.solicitud.idUsuario = localStorage.getItem("idUsuariosso");
    //this.solicitud.idUsuarioRuc = this.parametro.idUsuarioRuc;
    this.solicitud.claveActual = this.claveActual;
    this.solicitud.claveNueva = this.claveNueva;
    this.solicitud.idSesion = 0;
    //this.solicitud.idEstadoClave = "1";

    if (this.claveNueva.length < this.minClave) {
      this.mostrarMensajeDialog("La nueva contraseña debe ser al menos de " + this.minClave + " caracteres");
    } else {
      if (this.claveNueva == this.claveNuevaConfirmacion) {
        this.ssoService.cambiarClave(this.solicitud).then(res => {
          /*if (res.data.estado) {
            this.mostrarMensajeDialog("Se cambio la contraseña satisfactoriamente");
            this.dialogRef.close({ data: null, estado: "CANCELAR" });
          } else {
            this.mostrarMensajeDialog("No se puede cambiar la contraseña, por favor intentalo nuevamente");
          }*/
          if (res.data.idUsuario) {
            if(res.data.idPersona>0){
              this.mostrarMensajeDialog2(res.data.observacion);
            }else{
              this.mostrarMensajeDialog(res.data.observacion);
            }

            //this.dialogRef.close({ data: null, estado: "CANCELAR" });
          } else {
            this.mostrarMensajeDialog("No se puede cambiar la contraseña, por favor intentalo nuevamente");
          }
        });
      } else {
        this.mostrarMensajeDialog("La confirmación de la contraseña nueva no coinciden");
      }
    }
  }

  mostrarMensajeDialog(mensaje) {
    /*const dialogRef = this.dialog.open(XsMessageBoxComponent, {
      width: "400px",
      panelClass: "xs-message-box-dlg",
      disableClose: true,
      data: { titulo: "SSO", mensaje: mensaje, icono: "XS_IDEA"  }
    });*/

    Swal.fire({
      title: 'Error!',
      html: mensaje,
      icon: 'error',
      showCloseButton: true,
      showConfirmButton: false,
      customClass: {
        container: 'xs-swal-container-left',
      }
    })
  }
  mostrarMensajeDialog2(mensaje) {
    /*const dialogRef = this.dialog.open(XsMessageBoxComponent, {
      width: "400px",
      panelClass: "xs-message-box-dlg",
      disableClose: true,
      data: { titulo: "SSO", mensaje: mensaje, icono: "XS_IDEA"  }
    });*/

    Swal.fire({
      title: 'Conforme',
      html: mensaje,
      icon: 'success',
      showCloseButton: true,
      showConfirmButton: false,
      customClass: {
        container: 'xs-swal-container-left',
      }
    })
  }
}
